import BlobImageLoader from './BlobImageLoader';

export default function createCanvasFromBlob(
  ownerDocument: Document,
  blob: Blob,
): Promise<HTMLCanvasElement> {
  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    new BlobImageLoader(
      blob,
      (img) => {
        const { width, height } = img;
        const canvas = ownerDocument.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        if (context === null) {
          reject(new Error('Failed to get context.'));
        } else {
          context.drawImage(img, 0, 0);
          resolve(canvas);
        }
      },
      () => {
        reject(new Error('Failed to load as image.'));
      },
    );
  });
}
